import {Injectable} from '@angular/core';
import {OmapiIdsUtils} from '../../shared/utils/omapi-ids/omapi-ids-utils';

@Injectable()
export class UserTypeDataService {

  constructor() {
  }

  public setUserType(jwtToken: string) {
    OmapiIdsUtils.setUserTypeGlobally(jwtToken);
  }

  public setDarwinUserType(dwnType: string) {
    OmapiIdsUtils.setDarwinUserTypeGlobally(dwnType);
  }
}
